
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class LabourMasterSelectGrid extends Serenity.EntityGrid<LabourMasterRow, any> {
        protected getColumnsKey() { return 'OMS.LabourSelect'; }
        protected getDialogType() { return <any>LabourMasterDialog; }
        protected getIdProperty() { return LabourMasterRow.idProperty; }
        protected getLocalTextPrefix() { return LabourMasterRow.localTextPrefix; }
        protected getService() { return LabourMasterService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;
         
        protected getColumns() {
            var self = this;
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return self.rowSelection; }));
            //if (OMS.LabourMasterSelectGrid.IsSales) {
            //    columns.filter(x => x.name != 'Purchase Rate')
            //}
            //else {
            //    columns.filter(x => x.name != 'Sale Rate')
            //}
            let laborType = (TabAurous.GetConfigValue(1002));

            switch (laborType) {
                case '2':
                    break;
                case '3':
                    break;
                case '4':
                    break;
                case '5':
                    break;
                case '6':
                    columns = columns.filter(x => x.field != 'CategoryName' && x.field != 'SubCategoryName'
                        && x.field != 'BrandName' && x.field != 'CollectionName');
                    break;
            }


            return columns;
        };

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ forceFitColumns: true, rowHeight: 30 });
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);            
            return this;
        }

        private autoSize;

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }


        get selectedItems(): LabourMasterRow[] {
                var _this = this;
                return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
            }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;


            //var request = this.view.params;
            //if (this.options.hideRates && this.options.hideRates.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["RateID" /* RateID */], 'not in', [this.options.hideRates]]);
            return true;
           
        }
        
    }

    export interface LabourSelectOptions {
        ParentKey?: string;
        Key?: string;
        Title?: string;
        IsGroup?: boolean;
        GrantRevoke?: boolean;
    }
}